import { useDispatch } from 'react-redux'
/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react'
import TopHeader from '../../../../components/TopHeader'
import { motion } from 'framer-motion'
import DeviceAlerts from './DeviceAlert'
import ProvidersAlerts from './ProviderAlerts'
import { useSearchParams } from 'react-router-dom'
import { dataService } from '../../../../services/data.services'
import HelpGuideModal from '../../../../components/HelpGuideModal'
import {useGetHelpGuideProviderQuery} from '../../../../slices/patientSlice'
import { organizationusersList } from '../../../../slices/apiSlice'
import { resetDeviceAlertSearch } from '../../../../redux/deviceAlertReportSearchSlice'
import GlobalContext from '../../../../components/Context/GloablContext'

export default function AlertReport() {

    const [patientTabName, setPatientTabName] = useState('provider_alert')
    const [searchParams,setSearchParams] = useSearchParams('')
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [loadingState, setLoadingState] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
    const dispatch = useDispatch();
    const {isSearchOpen,setIsSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideProviderQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    // On initial render, set the tab based on the search param 'tab'
    useEffect(() => {
        const initialTab = searchParams.get('tab') || 'provider_alert';
        setPatientTabName(initialTab); // Set the tab from the URL or fallback to default
    }, [searchParams]);
    

    const handleTabChange = async (tabName) => {
        if (patientTabName !== tabName) {
            dispatch(organizationusersList.util.resetApiState())        
            setPatientTabName(tabName)
            dispatch(resetDeviceAlertSearch())
            setIsSearchOpen(false);
            setSearchParams(`tab=${tabName}`);
            await makeActivityHistoryApiCall(tabName)
        }
    }

    const makeActivityHistoryApiCall = async (tabName) =>{
        try {
            const response = await dataService.PostAPI({}, `users/activity-logs?action=view-alerts&tab=${tabName}`)
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        makeActivityHistoryApiCall(patientTabName)
    }, [])
    
    useEffect(() => {
        if (userType === 'monitor-user') {
            setQueryParamsorg('type=monitor-alerts-report');
        } else {
            setQueryParamsorg('type=provider-alerts-report');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Alert Reports"} />
               
                <>
                    <div className='rounded-lg h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div>
                                <div>
                                    <div className='ml-7 flex justify-between items-end h-12'>
                                        <div className='flex  pb-2 overflow-x-auto overflow-y-visible scrollBar-hidden 
                                            border-b border-[#E7CBD2] w-full'>
                                            <button disabled={loadingState} id={'provider_alert'} data-testid="provider_alert" onClick={() => { handleTabChange('provider_alert') }} className={`px-2 pt-2.5 min-w-fit text-base font-semibold ${patientTabName === 'provider_alert' ? 'text-[#972E4C]' : 'text-[#030E06] '} relative ${patientTabName === 'provider_alert' ? 'patient_tab' : ''}`}>
                                                Provider Alerts
                                            </button>
                                            <button disabled={loadingState} id={'decive_alerts'} data-testid="decive_alerts" onClick={() => { handleTabChange('decive_alerts') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'decive_alerts' ? 'text-[#972E4C]' : 'text-[#030E06] '} relative ${patientTabName === 'decive_alerts' ? 'patient_tab' : ''}`}>
                                                Device Alerts
                                            </button>
                                        </div>
                                        <span   onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                                            <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                        </span> 
                                    </div>
                                    {patientTabName==='provider_alert' && <ProvidersAlerts tab={patientTabName} setLoadingState={setLoadingState} /> }
                                    {patientTabName==='decive_alerts' && <DeviceAlerts tab={patientTabName} setLoadingState={setLoadingState} /> }
                                </div>
                            </div>
                            {(helpGuideModel && helpguidestatus==="fulfilled") &&
                            <HelpGuideModal
                                setHelpGuideModel={setHelpGuideModel}
                                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                            />
                            }
                        </motion.div>
                    </div>
                </>
            </div>
        </> 
    )
}
